var map = {
	"./agro.svg": "6bf3",
	"./apertura.svg": "bc63",
	"./card-text.svg": "f61d",
	"./contenedor.svg": "bb89",
	"./cpu.svg": "c945",
	"./dashboard-blue.svg": "b2dc",
	"./dashboard-desploy-blue.svg": "3830",
	"./energy.svg": "04da",
	"./energy_label_blue.svg": "f30b",
	"./etiquetas.svg": "fbaf",
	"./gas.svg": "56cf",
	"./gateways_admin.svg": "5391",
	"./kws.svg": "9ae5",
	"./mascotas.svg": "2ace",
	"./moobel.svg": "cfe9",
	"./panicbutton.svg": "f8bb",
	"./pointtracker.svg": "c349",
	"./polucion.svg": "b6e6",
	"./smart_agro.svg": "17c2",
	"./smarthue.svg": "2c00",
	"./sonido.svg": "cd7e",
	"./ssmartlocator.svg": "5d9e",
	"./temperature.svg": "e077",
	"./water.svg": "3206"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4827";